export const BlobToBase = async (blob: Blob): Promise<string> => {
  return URL.createObjectURL(blob) ;
};
